import React, { FC } from 'react';
import { ErrorPage } from '@clearcover/atlas';
import { Button } from '@clearcover/atlas';
import { Link, useHistory } from 'react-router-dom';
import styles from './styles.module.css';
import { FallbackProps } from 'react-error-boundary';

export const ErrorBoundaryPage: FC<FallbackProps> = ({
  error,
  componentStack,
}) => {
  const errorMessage = error?.message ?? 'An error occurred';
  const { go } = useHistory();

  return (
    <ErrorPage
      errorMessage={errorMessage}
      key="error"
      componentStack={componentStack || ''}
    >
      <h1 data-testid="error-boundary">Oops. Something went wrong.</h1>
      <h2>Developers have been notified.</h2>
      <>{error && <pre className={styles.error}>{errorMessage}</pre>}</>
      <div className={styles.returnButtonWrapper}>
        <Button
          data-testid="error-back-to-application"
          variant="secondary"
          onClick={() => go(0)} // this forces refresh on current page
        >
          Retry
        </Button>
        <Link to="/quotes">
          <Button data-testid="error-return-to-portal" variant="primary">
            Return to Portal
          </Button>
        </Link>
      </div>
    </ErrorPage>
  );
};
